import React from 'react';
import styled from 'styled-components';

const useWindowSize = () => {
  const [windowSize, setWindowSize] = React.useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  React.useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
};

// const ListContainer = styled.div`
//   display: grid;
//   grid-auto-flow: ${(props) => (props.horizontal ? 'column' : 'row')};
//   grid-template-columns: ${(props) =>
//     !props.horizontal ? `repeat(${props.numColumns}, 1fr)` : 'none'};
//   grid-template-rows: ${(props) =>
//     props.horizontal ? `repeat(${props.numColumns}, 1fr)` : 'none'};
//   gap: ${(props) => props.gap || '16px'};
//   padding: ${(props) => props.padding || '8px'};
//   overflow-x: ${(props) => (props.horizontal ? 'auto' : 'visible')};
//   ${(props) => props.customStyle};
// `;
const ListContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(${(props) => props.numColumns}, 1fr);
  row-gap: ${(props) => props.rowGap || props.gap || '16px'};
  column-gap: ${(props) => props.columnGap || props.gap || '16px'};
  padding: ${(props) => props.padding || '8px'};
  ${(props) => props.customStyle};
`;

const ItemContainer = styled.div`
  /* Remove flexbox properties that conflict with CSS Grid */
  /* The grid will handle sizing automatically */
`;

// 메인 ListView 컴포넌트
const ListView = ({
  data,
  renderItem,
  keyExtractor = (item, index) => index.toString(),
  horizontal = false,
  numColumns = 1,
  gap,
  rowGap,
  columnGap,
  padding,
  style,
  ...props
}) => {
  const windowSize = useWindowSize();

  // 반응형 컬럼/로우 계산
  const calculateColumns = () => {
    if (typeof numColumns === 'function') {
      return numColumns(windowSize.width, windowSize.height);
    }
    return numColumns;
  };

  const currentNumColumns = calculateColumns();

  // Filter out null items before rendering to prevent empty grid slots
  const validItems = data
    .map((item, index) => {
      const renderedItem = renderItem({ item, index });
      return renderedItem ? { item, index, renderedItem } : null;
    })
    .filter(Boolean);

  return (
    <ListContainer
      horizontal={horizontal}
      numColumns={currentNumColumns}
      gap={gap}
      rowGap={rowGap}
      columnGap={columnGap}
      padding={padding}
      customStyle={style}
      {...props}
    >
      {validItems.map(({ item, index, renderedItem }) => (
        <ItemContainer
          key={keyExtractor(item, index)}
          horizontal={horizontal}
          numColumns={currentNumColumns}
        >
          {renderedItem}
        </ItemContainer>
      ))}
    </ListContainer>
  );
};

export default ListView;
